export enum TunnelPaiementStepsEnum {
  LOCATION = 'locationv2',
  ALREADY_CODE = 'already_codev2',
  ALREADY_DRIVE = 'already_drivev2',
  GEARBOX_TYPE = 'select_gearbox',
  DRIVING_HOURS = 'select_hourv2',
  RECAP = 'recap',
  TUNNEL = 'tunnelpaiementv2',
}
